import React, { useState, useEffect } from 'react'

import { Heading } from '../components/Heading';
import { NavConversion } from '../components/NavConversion';
import ConversionList from '../components/ConversionList';
import ISBNList from '../components/ISBNList';
import PortadasList from '../components/PortadasList';
import Autocomplete from '../components/Autocomplete';
import { urlInk, endpointGetAccounts } from '../services/Endpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSync } from '@fortawesome/free-solid-svg-icons';

export function Conversion() {
    const [activeTab, setActiveTab] = useState('list');
    const [accounts, setAccounts] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [filters, setFilters] = useState({
        status: '',
        account: '',
        ink_id: ''
    });

    useEffect(() => {
        getAccounts();
    }, []);

    const getAccounts = async () => {
        try {
            const response = await fetch(`${urlInk}${endpointGetAccounts}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const res = await response.json();
            if (res && res.status === 'success') {
                setAccounts(res.data);
            }
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    }

    const handleReload = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAccountChange = (option) => {
        setFilters(prev => ({
            ...prev,
            account: option.value
        }));
    };

    const clearAccount = () => {
        setFilters(prev => ({
            ...prev,
            account: ''
        }));
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const title = 'Conversiones';

    return (
        <>
            <Heading title={title} />

            <section className="container mt-5 pb-4 border-bottom border-secondary">
                {/* Filters Row */}
                <div className="row g-4 align-items-end">
                    <div className="col-md-5 col-lg-4">
                        <label className="fw-bold mb-3 d-block text-white" style={{ fontSize: '1.1rem' }}>Filtrar por Cuenta</label>
                        <Autocomplete options={accounts} onChange={handleAccountChange} isDark={true} />
                    </div>

                    <div className="col-md-4 col-lg-3">
                        <label className="fw-bold mb-3 d-block text-white" style={{ fontSize: '1.1rem' }}>Ink ID</label>
                        <div className="d-flex gap-2">
                            <input
                                type="text"
                                className="form-control bg-dark text-white border-secondary py-2"
                                name="ink_id"
                                placeholder="Ej: 123456"
                                value={filters.ink_id}
                                onChange={handleFilterChange}
                            />
                            <button 
                                className="btn btn-ink-icon"
                                onClick={handleReload}
                                title="Recargar datos"
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Feedback Row (to avoid layout shift) */}
                <div className="row mt-3">
                    <div className="col-12">
                        {filters.account !== '' && (
                            <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1">
                                <span className="me-2 fw-medium text-white small">{filters.account}</span>
                                <button
                                    onClick={clearAccount}
                                    className="btn btn-link p-0 text-danger"
                                    style={{ textDecoration: 'none', lineHeight: 1 }}
                                >
                                    <FontAwesomeIcon icon={faClose} size="sm" />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <NavConversion handleTabChange={handleTabChange} />

            <div className="container">
                {activeTab === 'list' && <ConversionList filters={filters} refreshKey={refreshKey} />}
                {activeTab === 'isbn' && <ISBNList filters={filters} refreshKey={refreshKey} />}
                {activeTab === 'portadas' && <PortadasList filters={filters} refreshKey={refreshKey} />}
            </div>
        </>
    )
}

export default Conversion